<script>
    import ErrorPage from '../components/pages/ErrorPage/ErrorPage';

    export default {
        extends: ErrorPage,
    };
</script>
